
/* =========================================================
   MADSPEED7 — DYNAMIC CANDYRACK TYRE MESSAGE
   ========================================================= */

(function () {
  'use strict';

  function getPrice(element) {
    if (!element) return 0;

    const text = element.textContent
      .replace(/,/g, '')
      .replace(/[^0-9.]/g, '');

    return parseFloat(text) || 0;
  }

  function updateTyreMessages() {
    const container = document.querySelector(
      '#candyrack-slider-cart'
    );

    if (!container) return;

    container.querySelectorAll(
      '.candyrack-slider-cart-offer-item-wrapper'
    ).forEach(function (offer) {

      const title = offer.querySelector(
        '.candyrack-slider-cart-offer-item-header'
      );

      const priceWrapper = offer.querySelector(
        '.candyrack-slider-cart-offer-price-wrapper'
      );

      if (!title || !priceWrapper) return;

      const productTitle = title.textContent || '';
      const productUrl = title.getAttribute('href') || '';

      const isTyre = /tyre|tire/i.test(
        productTitle + ' ' + productUrl
      );

      const existingMessage = offer.querySelector(
        '.ms7-candyrack-promo-message'
      );

      if (!isTyre) {
        if (existingMessage) existingMessage.remove();
        return;
      }

      const originalPrice = getPrice(
        offer.querySelector(
          '.candyrack-slider-cart-offer-price-crossed'
        )
      );

      const discountedPrice = getPrice(
        offer.querySelector(
          '.candyrack-slider-cart-offer-price-discounted'
        )
      );

      if (
        originalPrice <= 0 ||
        discountedPrice <= 0 ||
        discountedPrice >= originalPrice
      ) {
        if (existingMessage) existingMessage.remove();
        return;
      }

      const discount = Math.round(
        ((originalPrice - discountedPrice) / originalPrice) * 100
      );

      if (
        existingMessage &&
        existingMessage.dataset.discount === String(discount)
      ) {
        return;
      }

      if (existingMessage) existingMessage.remove();

      const message = document.createElement('div');
      message.className = 'ms7-candyrack-promo-message';
      message.dataset.discount = String(discount);

      message.innerHTML = `
        <div class="ms7-candyrack-saving">
          <span>Add this tyre and </span>
          <span class="ms7-candyrack-saving-value">save ${discount}%</span>
        </div>
        <div class="ms7-candyrack-fitting">
          Tyre/s will come fitted at no extra cost
        </div>
      `;

      priceWrapper.insertAdjacentElement('afterend', message);

    });
  }

  let scheduled = false;

  function scheduleUpdate() {
    if (scheduled) return;

    scheduled = true;

    requestAnimationFrame(function () {
      scheduled = false;
      updateTyreMessages();
    });
  }

  function start() {
    scheduleUpdate();

    const observer = new MutationObserver(scheduleUpdate);

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

})();
